export { renderMethod } from './decorators';
export { isColor } from './colors';
export * from './helpers';
export {KvConfig, getApiConfig} from './backend';
